var map = {
	"./1AGP.png": 85906,
	"./2AGP.png": 97815,
	"./3AGP.png": 65766,
	"components/Catalog/AGP/img/glass/t/tPlusSilver/1AGP.png": 85906,
	"components/Catalog/AGP/img/glass/t/tPlusSilver/2AGP.png": 97815,
	"components/Catalog/AGP/img/glass/t/tPlusSilver/3AGP.png": 65766
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 34565;